/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2023, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * Directive for the mismatched version alert showed when a user's client version doesn't match the server version.
 */
angular.module('bulbApp.alertsModule')
  .directive('bulbMismatchedVersionAlert', bulbMismatchedVersionAlert);

function bulbMismatchedVersionAlert() {
  return {
    restrict: 'E',
    scope: true,
    controller: 'MismatchedVersionAlertController as mismatchedVersionAlertCtrl',
    templateUrl: 'ajs/alerts/mismatchedversionalert.html',
  };
}
